import { render, staticRenderFns } from "./BarcodeControls.vue?vue&type=template&id=25d4878d&"
import script from "./BarcodeControls.vue?vue&type=script&lang=ts&"
export * from "./BarcodeControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports